var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vote-progress"},[_c('el-progress',{attrs:{"percentage":_vm.percentage,"show-text":false,"stroke-width":4}}),_c('div',{staticClass:"progress-text-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.count)+" 票")]),_c('span',[_vm._v(_vm._s(_vm.percentage)+"%")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }